import React, {useState} from 'react';

import css from "./Login.module.scss";
import "../../styles/index.scss"
import CommonInput from "../common/CommonInput/CommonInput";
import {Formik} from "formik";
import {Redirect, withRouter} from "react-router-dom";
import * as Yup from "yup";
import {authApi} from "../../redux/auth/auth-api";
import {connect} from "react-redux";
import {login} from "../../redux/auth/auth-thunks";
import instance from "../../redux/instance";
import {useTranslation} from "react-i18next";


const Login = (props) => {
  const [isShowPassword, setIsShowPassword] = useState(false)
  const {t} = useTranslation()
  if (props.token) {
    // Object.assign(instance.defaults, {headers: {Authorization: `Bearer ${props.token}`}});
    return <Redirect to={'/logbook'}/>
  }
  return (
    <div className={css.formWrapper}>
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={Yup.object({
          email: Yup.string()
            .required(t('requiredField')),
          password: Yup.string()
            .required(t('requiredField')),
        })}
        onSubmit={async (values) => {
          props.login(values.email, values.password)
        }}
      >
        {formikProps => {
          return (
            <form onSubmit={formikProps.handleSubmit}>
              <CommonInput type={'email'} caption={'Email'}
                           value={formikProps.values.email} setValue={formikProps.handleChange} id={'email'}
                           error={(formikProps.submitCount > 0 && formikProps.errors.email) || props.isLoginError}
              />
              <CommonInput type={'password'} caption={t('password')} isPassword={true} isShowPassword={isShowPassword}
                           setIsShowPassword={() => setIsShowPassword(!isShowPassword)}
                           isShowForgot={true}
                           value={formikProps.values.password} setValue={formikProps.handleChange} id={'password'}
                           error={(formikProps.submitCount > 0 && formikProps.errors.password) || (props.isLoginError && t('emailOrPasswordIncorrect'))}
              />
              <button onClick={formikProps.handleSubmit} className={'submit-button'}>
                <span style={{margin: '0 12px'}}>{t('signIn')}</span>
              </button>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.authReducer.token,
  isLoginError: state.authReducer.isLoginError
})

export default connect(mapStateToProps, {login})(React.memo(Login));
